import { useContext } from 'react';
import './style.scss';
import { FormDataContext } from '../FormDataProvider';

function ContactStep() {

    const { updateFormData } = useContext(FormDataContext);

    var counties = {
        K: "Blekinge län",
        W: "Dalarnas län",
        I: "Gotlands län",
        X: "Gävleborgs län",
        N: "Hallands län",
        Z: "Jämtlands län",
        F: "Jönköpings län",
        H: "Kalmar län",
        G: "Kronobergs län",
        BD: "Norrbottens län",
        M: "Skåne län",
        A: "Stockholms län",
        D: "Södermanlands län",
        C: "Uppsala län",
        UT: "Utlandet",
        S: "Värmlands län",
        AC: "Västerbottens län",
        Y: "Västernorrlands län",
        U: "Västmanlands län",
        O: "Västra Götalands län",
        T: "Örebro län",
        E: "Östergötlands län"
    };

    var countries = {
        AF: "Afghanistan",
        AL: "Albanien",
        DZ: "Algeriet",
        AS: "Amerikanska Samoa",
        AD: "Andorra",
        AO: "Angola",
        AI: "Anguilla",
        AQ: "Antarktis",
        AG: "Antigua och Barbuda",
        AR: "Argentina",
        AM: "Armenien",
        AW: "Aruba",
        AU: "Australien",
        AZ: "Azerbajdzjan",
        BS: "Bahamas",
        BH: "Bahrain",
        BD: "Bangladesh",
        BB: "Barbados",
        BE: "Belgien",
        BZ: "Belize",
        BJ: "Benin",
        BM: "Bermuda",
        BT: "Bhutan",
        BO: "Bolivia",
        BQ: "Bonaire",
        BA: "Bosnien och Hercegovina",
        BW: "Botswana",
        BV: "Bouvetön",
        BR: "Brasilien",
        IO: "Brittiskt territorium i Indiska Oceanen",
        BN: "Brunei",
        BG: "Bulgarien",
        BF: "Burkina Faso",
        BI: "Burundi",
        KY: "Caymanöarna",
        CF: "Centralafrikanska republiken",
        CL: "Chile",
        CO: "Colombia",
        CK: "Cooköarna",
        CR: "Costa Rica",
        CI: "Côte d’Ivoire",
        CW: "Curaçao",
        CY: "Cypern",
        DK: "Danmark",
        PS: "Den palestinska myndigheten",
        DJ: "Djibouti",
        DM: "Dominica",
        DO: "Dominikanska republiken",
        EC: "Ecuador",
        EG: "Egypten",
        GQ: "Ekvatorialguinea",
        SV: "El Salvador",
        ER: "Eritrea",
        EE: "Estland",
        ET: "Etiopien",
        MK: "F.d. jugoslaviska republiken Makedonien",
        FK: "Falklandsöarna (Islas Malvinas)",
        FJ: "Fijiöarna",
        PH: "Filippinerna",
        FI: "Finland",
        FR: "Frankrike",
        GF: "Franska Guyana",
        PF: "Franska Polynesien",
        TF: "Franska territorier på södra halvklotet",
        FO: "Färöarna",
        AE: "Förenade Arabemiraten",
        GA: "Gabon",
        GM: "Gambia",
        GE: "Georgien",
        GH: "Ghana",
        GI: "Gibraltar",
        GR: "Grekland",
        GD: "Grenada",
        GL: "Grönland",
        GP: "Guadeloupe",
        GU: "Guam",
        GT: "Guatemala",
        GG: "Guernsey",
        GN: "Guinea",
        GW: "Guinea-Bissau",
        GY: "Guyana",
        HT: "Haiti",
        HM: "Heardön och Mcdonaldöarna",
        HN: "Honduras",
        HK: "Hongkong SAR",
        IN: "Indien",
        ID: "Indonesien",
        IQ: "Irak",
        IR: "Iran",
        IE: "Irland",
        IS: "Island",
        IM: "Isle of Man",
        IL: "Israel",
        IT: "Italien",
        JM: "Jamaica",
        SJ: "Jan Mayen",
        JP: "Japan",
        YE: "Jemen",
        JE: "Jersey",
        JO: "Jordanien",
        CX: "Julön",
        VI: "Jungfruöarna (Amerikanska)",
        VG: "Jungfruöarna (Brittiska)",
        KH: "Kambodja",
        CM: "Kamerun",
        CA: "Kanada",
        CV: "Kap Verde",
        KZ: "Kazakstan",
        KE: "Kenya",
        CN: "Kina",
        KG: "Kirgizistan",
        KI: "Kiribati",
        CC: "Kokosöarna",
        KM: "Komorerna",
        CD: "Kongo-Kinshasa",
        KR: "Korea",
        HR: "Kroatien",
        CU: "Kuba",
        KW: "Kuwait",
        LA: "Laos",
        LS: "Lesotho",
        LV: "Lettland",
        LB: "Libanon",
        LR: "Liberia",
        LY: "Libyen",
        LI: "Liechtenstein",
        LT: "Litauen",
        LU: "Luxemburg",
        MO: "Macau SAR",
        MG: "Madagaskar",
        MW: "Malawi",
        MY: "Malaysia",
        MV: "Maldiverna",
        ML: "Mali",
        MT: "Malta",
        MA: "Marocko",
        MH: "Marshallöarna",
        MQ: "Martinique",
        MR: "Mauretanien",
        MU: "Mauritius",
        YT: "Mayotte",
        MX: "Mexiko",
        FM: "Mikronesien",
        MZ: "Moçambique",
        MD: "Moldavien",
        MC: "Monaco",
        MN: "Mongoliet",
        ME: "Montenegro",
        MS: "Montserrat",
        MM: "Myanmar",
        NA: "Namibia",
        NR: "Nauru",
        NL: "Nederländerna",
        NP: "Nepal",
        NI: "Nicaragua",
        NE: "Niger",
        NG: "Nigeria",
        NU: "Niue",
        KP: "Nordkorea",
        NF: "Norfolkön",
        NO: "Norge",
        MP: "Norra Marianaöarna",
        NC: "Nya Kaledonien",
        NZ: "Nya Zeeland",
        OM: "Oman",
        PK: "Pakistan",
        PW: "Palau",
        PA: "Panama",
        PG: "Papua Nya Guinea",
        PY: "Paraguay",
        PE: "Peru",
        PN: "Pitcairn",
        PL: "Polen",
        PT: "Portugal",
        PR: "Puerto Rico",
        QA: "Qatar",
        CG: "Republiken Kongo",
        RE: "Réunion",
        RO: "Rumänien",
        RW: "Rwanda",
        RU: "Ryssland",
        XS: "Saba",
        SH: "Saint Helena",
        PM: "Saint Pierre och Miquelon",
        BL: "Saint-Barthélemy",
        MF: "Saint-Martin",
        WS: "Samoa",
        SM: "San Marino",
        ST: "Sao Tome och Principe",
        SA: "Saudiarabien",
        CH: "Schweiz",
        SN: "Senegal",
        RS: "Serbien",
        SC: "Seychellerna",
        SL: "Sierra Leone",
        SG: "Singapore",
        XE: "Sint Eustatius",
        SX: "Sint Maarten",
        SK: "Slovakien",
        SI: "Slovenien",
        SB: "Solomonöarna",
        SO: "Somalia",
        ES: "Spanien",
        LK: "Sri Lanka",
        KN: "St Kitts och Nevis",
        LC: "St Lucia",
        VC: "St Vincent och Grenadinerna",
        UK: "Storbritannien",
        SD: "Sudan",
        SR: "Surinam",
        SZ: "Swaziland",
        SE: "Sverige",
        ZA: "Sydafrika",
        GS: "Sydgeorgien och Sydsandwichöarna",
        SY: "Syrien",
        TJ: "Tadzjikistan",
        TW: "Taiwan",
        TZ: "Tanzania",
        TD: "Tchad",
        TH: "Thailand",
        TL: "Timor-Leste",
        CZ: "Tjeckien",
        TG: "Togo",
        TK: "Tokelauöarna",
        TO: "Tonga",
        TT: "Trinidad och Tobago",
        TN: "Tunisien",
        TR: "Turkiet",
        TM: "Turkmenistan",
        TC: "Turks- och Caicosöarna",
        TV: "Tuvalu",
        DE: "Tyskland",
        UG: "Uganda",
        UA: "Ukraina",
        HU: "Ungern",
        UY: "Uruguay",
        US: "USA",
        UM: "USA:s mindre öar i Oceanien och Västindien",
        UZ: "Uzbekistan",
        WF: "Wallisarkipelagen",
        VU: "Vanuatu",
        VA: "Vatikanstaten",
        VE: "Venezuela",
        VN: "Vietnam",
        BY: "Vitryssland",
        ZM: "Zambia",
        ZW: "Zimbabwe",
        AX: "Åland",
        AT: "Österrike",
        XX: "Annat"
    }

  return (
    <div className="contact-info-step">
      <h2>Kontaktinformation</h2>
        <form>
            <label className="full">
                Telefonnummer
                <input type="text" name="phone" placeholder="Telefonnummer" onChange={(e) => updateFormData(e)} required />
            </label> 
            <label className="full">
                E-post
                <input type="text" name="email" placeholder="E-post" onChange={(e) => updateFormData(e)} required />
            </label> 
            <label className="full">
                Gatuadress
                <input type="text" name="address_street" placeholder="Gatuadress" onChange={(e) => updateFormData(e)} required />
            </label> 
            <label>
                Postnummer
                <input type="text" name="address_zipcode" placeholder="Postnummer" onChange={(e) => updateFormData(e)} required />
            </label>
            <label>
                Ort
                <input type="text" name="address_city" placeholder="Ort" onChange={(e) => updateFormData(e)} required />
            </label>
            <label className="dropdown">
                Land
                <select name="country" onChange={(e) => updateFormData(e)} required>
                    <option value="" defaultValue={''} disabled>Välj ...</option>
                    {Object.keys(countries).map((key) => {
                        return (
                            <option key={key} value={key} selected={key == 'SE'}>{countries[key]}</option>
                        )
                    })}
                </select>
            </label>
            <label className="dropdown">
                Län
                <select name="county" onChange={(e) => updateFormData(e)} required>
                    <option value="" defaultValue={''} disabled>Välj ...</option>
                    {Object.keys(counties).map((key) => {
                        return (
                            <option key={key} value={key}>{counties[key]}</option>
                        )
                    })}
                </select>
            </label>
            { /*
            <label className="full">
                C/O Adress / Företag
                <input type="text" name="co" placeholder="C/O Adress / Företag" onChange={(e) => updateFormData(e)} />
            </label>
            */ } 
        </form>
    </div>
  );
}

export default ContactStep;
